import { Injectable, Inject, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';

@Injectable({
  providedIn: 'root',
})
export class StorageService {
  constructor(@Inject(PLATFORM_ID) private platformId: Object) {}

  // Set a value in local storage
  saveToLocal(key: string, value: any): void {
    if (isPlatformBrowser(this.platformId)) {
    localStorage.setItem(key, value);
    }
  }

  // Get a value from local storage
  retrieveFromLocal(key: any): any | null {
    if (isPlatformBrowser(this.platformId)) {
    return localStorage.getItem(key);
    }
    return null;
  }

  // Remove a value from local storage
  clearFromLocal(key: string): void {
    if (isPlatformBrowser(this.platformId)) {
    localStorage.removeItem(key);
    }
  }

  // Clear all items from local storage
  clearAllFromLocal(): void {
    if (isPlatformBrowser(this.platformId)) {
    localStorage.clear();
    }
  }
}


// import { Injectable } from '@angular/core';
// import { LocalStorageService } from 'ngx-webstorage';

// @Injectable({
//   providedIn: 'root',
// })
// export class StorageService {
//   constructor(protected localStore: LocalStorageService) {}

//   saveToLocal(key: string, value: string) {
//     this.localStore.store(key, value);
//   }

//   retrieveFromLocal(key: string) {
//     return this.localStore.retrieve(key);
//   }

//   clearFromLocal(key: string) {
//     return this.localStore.clear(key);
//   }

//   clearAllFromLocal() {
//     return localStorage.clear();
//   }
// }
